(function angucompleteExtendModuleDefinition() {

    'use strict';

    angular.module('angucompleteExtend', [])
        .directive('angucompleteAlt', function () {
            return {
                restrict: 'E',
                priority: 500,
                link: function (scope, element, attributes) {                   
                    var innerScope = element.isolateScope();
                    innerScope.inputTabIndex = scope.$eval(attributes.inputTabIndex);
                    innerScope.inputRequired = scope.$eval(attributes.inputRequired);
                }

            }
        });
})();
